/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from '@reduxjs/toolkit';

import { InjectedReducersType } from 'utils/types/injector-typings';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

export function createReducer(injectedReducers: InjectedReducersType = {}) {
  // Initially we don't have any injectedReducers, so returning identity function to avoid the error
  console.log('Injected Reducers:', injectedReducers); // Debug log
  const rootReducer = combineReducers({
    // Các reducer cố định
    staticReducer: (state = {}) => state,
    ...injectedReducers,
  });

  return rootReducer;
}
